const n = (f) => {
  const {
    tooltip: i,
    isLocked: o = !1,
    lockedTooltip: t,
    itemLabel: r,
    isDisabled: a = !1,
    isOverflowing: p = !1
  } = f;
  let l;
  o && t ? l = t : i ? l = i : l = r;
  let s = !1;
  a && i && (s = !0);
  let e = !1;
  return i || s ? e = !0 : o ? t && (e = !0) : p && (e = !0), {
    tooltipTitle: l,
    showTooltip: e
  };
};
export {
  n as getTooltipByConditions
};
//# sourceMappingURL=index.es554.js.map
